import type { FunctionComponent } from 'react';

import type { QuestionnaireBlock } from '../../data-contract/chat';
import { QuestionnaireInputOverride } from './components/QuestionnaireInputOverride';
import { QuestionnaireThread } from './components/questionnaire-flow';
import type { BlockRenderContext, BlockRenderer } from './types';

const QuestionnaireInline: FunctionComponent<{
    readonly block: QuestionnaireBlock;
    readonly context: BlockRenderContext;
}> = ({ block, context }) => {
    if (block.mode === 'Review' && context.interactive) {
        return (
            <div className="flex justify-start">
                <QuestionnaireInputOverride
                    key={block.blockId}
                    blockId={block.blockId}
                    eventId={context.eventId}
                    questions={block.questions}
                    showCompletedThread={true}
                />
            </div>
        );
    }

    return <QuestionnaireThread blockId={block.blockId} questions={block.questions} />;
};

export const questionnaireBlockRenderer: BlockRenderer<QuestionnaireBlock> = {
    isAnswered: (block) => block.mode === 'Result',
    renderInline: (block, context) => <QuestionnaireInline block={block} context={context} />,
    rendersInlineContent: () => true,
    renderInputOverride: (block) => {
        if (block.mode !== 'Review') return null;
        return { node: null, suppressInputChrome: true };
    },
    type: 'questionnaire',
};
